var map = {
	"./A33000kmwalkfromhumansbirthplace.jpg": 807,
	"./AtightlyguardedHimalayansecret.jpg": 484,
	"./JaneGoodallsreasonstobehopeful.jpg": 6468,
	"./OneoftheAmericaslastkingdoms.jpg": 8045,
	"./TheIndianaJonesoftheCaribbean.jpg": 9537,
	"./TheSwedishchefwhoreinventedfire.jpg": 4282,
	"./ThecruciallegacymissingfromUSfood.jpg": 669,
	"./Wherepeoplegotobarstodrinkmilk.jpg": 7676,
	"./arrowNext.svg": 7022,
	"./arrowPrev.svg": 8121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 902;